module.exports = __webpack_public_path__ + "static/media/kids.9c800cee.png";